import {put,takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';

import {TYPES as STATUS_COMMENT_TYPE} from '../../creators/user.status.comment';

export function* createSuccess(action) {
    try {
        yield put({type: "STATUS_COMMENTS_ADD", data : action.payload});
        // yield put({type: "USER_TIMELINES_INCREMENT_COMMENT", data : action.payload});
    } catch (error) {

    }
}

export function* deleteSuccess(action) {
    try {
        yield put({type: "STATUS_COMMENTS_DELETE", data : action.payload});
        // yield put({type: "USER_TIMELINES_DECREMENT_COMMENT", data : action.payload});
    } catch (error) {

    }
}

export function* updateSuccess(action) {
    try {
        yield put({type: "STATUS_COMMENTS_UPDATE", data : action.payload});
    } catch (error) {

    }
}

export function* watchStoryComment() {
    yield takeEvery(STATUS_COMMENT_TYPE.CREATE_SUCCESS, createSuccess);
    yield takeEvery(STATUS_COMMENT_TYPE.DELETE_SUCCESS, deleteSuccess);
    yield takeEvery(STATUS_COMMENT_TYPE.UPDATE_SUCCESS, updateSuccess);
}

export default watchStoryComment;

